<div
  #mapAndSubappContainer
  [ngClass]="displayService.isSubAppActive ? 'mapAndSubappWrapper' : 'regularMapWrapper'"
  >

    <!-- Display fullscreen toggle button if fullscreen option is configured in db for app and device is iOS -->
    @if(applicationSettings?.option?.map?.map_tools?.fullscreen && isIOS) {
    <button class="fullscreen-button" [class.fullscreen-button-fixed]="isFullscreen"
      [matTooltip]="isFullscreen ? selText.turnOffFullscreenMode : selText.turnOnFullscreenMode"
      matTooltipClass="tooltipStyle" (click)="toggleFullscreenForIos()">
      <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
    </button>
    }

  <div
    #mapElement
    class="map"
    id="mapid"
    tabindex="0"
    [style.position]="(displayService.splitMapActive$ | async) ? 'absolute' : 'relative'"
    >
    @if ((displayService.splitMapActive$ | async) && displayService.enableSplitMap) {
      <button
        id="closeSplitMap"
        (click)="displayService.splitMapActive$.next(false)"
        [matTooltip]="selText.deactivateSplitMap" matTooltipClass="tooltipStyle"
        >
        <mat-icon id="closeSplitMapArrow">keyboard_arrow_right</mat-icon>
      </button>
    }
    @if ((displayService.splitMapActive$ | async) === false && displayService.enableSplitMap) {
      <button
        id="openSplitMap"
        (click)="displayService.splitMapActive$.next(true)"
        [matTooltip]="selText.activateSplitMap" matTooltipClass="tooltipStyle"
        >
        <mat-icon id="openSplitMapArrow">keyboard_arrow_left</mat-icon>
      </button>
    }
    <input id="splitMapSlider" min="15" max="85" type="range" step="any" />
    <!-- The conditional styling with isLayerTimelineVisible$... Should be fixed properly later -->
    <div id="splitMapControlsContainer" [style.height] = "(displayService.isLayerTimelineVisible$ | async) ? 'calc(100% - 70px)' : '100%'" [style.margin-top] = "(displayService.isLayerTimelineVisible$ | async) ? '70px' : '0px'">
      <div id = "splitMapControlsMovingContainer">
        <div id = "verticalLineContainer">
          <IMG id="sliderImage" src="assets/images/left-right-arrow.png" />
        </div>

        <div id = "selectMapsLeft">
          <button
            mat-raised-button
            (click)="toggleBaseMapsMenuLeft()"
            >
            {{ selText.baseMaps }}
          </button>
          @if (baseMapsMenuLeftOpen) {
            <app-layer-list
              class="layerListLeft"
              [mapLayers]="mapLayers"
              [layerStateObs]="[layerService.checkedState$, layerService.legendState$, layerService.layerFilterState$]"
              [layerTree]="layerService.basemapLayerTree"
              [splitMapActive]="displayService.splitMapActive$ | async"
              [selText]="selText"
              [lang]="lang"
              [isBasemapTree]="true"
              [applicationSettings]="applicationSettings"
              [mapObject]="mapObject"
              [isSecondaryMap]="false"
              (closeLayerList)="baseMapsMenuLeftOpen = !baseMapsMenuLeftOpen"
              >
            </app-layer-list>
          }

          <button
            mat-raised-button
            (click)="toggleMapsMenuLeft()"
            >
            {{ selText.maps }}
          </button>
          @if (mapsMenuLeftOpen) {
            <app-layer-list
              class="layerListLeft"
              [mapLayers]="mapLayers"
              [layerStateObs]="[layerService.checkedState$, layerService.legendState$, layerService.layerFilterState$]"
              [layerTree]="layerService.layerTree"
              [splitMapActive]="displayService.splitMapActive$ | async"
              [selText]="selText"
              [lang]="lang"
              [isBasemapTree]="false"
              [applicationSettings]="applicationSettings"
              [mapObject]="mapObject"
              [isSecondaryMap]="false"
              (closeLayerList)="mapsMenuLeftOpen = !mapsMenuLeftOpen"
              >
            </app-layer-list>
          }
        </div>

        <div id = "selectMapsRight">
          <button
            mat-raised-button
            (click)="toggleMapsMenuRight()"
            >
            {{ selText.maps }}
          </button>
          @if (mapsMenuRightOpen) {
            <app-layer-list
              class="layerListRight"
              [mapLayers]="layerService.secondaryMapLayers"
              [layerStateObs]="[layerService.checkedState2$, layerService.legendState2$, layerService.layerFilterState2$]"
              [layerTree]="layerService.layerTree2"
              [splitMapActive]="displayService.splitMapActive$ | async"
              [selText]="selText"
              [lang]="lang"
              [isBasemapTree]="false"
              [applicationSettings]="applicationSettings"
              [mapObject]="mapObject"
              [isSecondaryMap]="true"
              (closeLayerList)="mapsMenuRightOpen = !mapsMenuRightOpen"
              >
            </app-layer-list>
          }
          <button
            mat-raised-button
            (click)="toggleBaseMapsMenuRight()"
            ><!-- color="primary" -->
            {{ selText.baseMaps }}
          </button>
          @if (baseMapsMenuRightOpen) {
            <app-layer-list
              class="layerListRight"
              [mapLayers]="layerService.secondaryMapLayers"
              [layerStateObs]="[layerService.checkedState2$, layerService.legendState2$, layerService.layerFilterState2$]"
              [layerTree]="layerService.basemapLayerTree2"
              [splitMapActive]="displayService.splitMapActive$ | async"
              [selText]="selText"
              [lang]="lang"
              [isBasemapTree]="true"
              [applicationSettings]="applicationSettings"
              [mapObject]="mapObject"
              [isSecondaryMap]="true"
              (closeLayerList)="baseMapsMenuRightOpen = !baseMapsMenuRightOpen"
              >
            </app-layer-list>
          }
        </div>
      </div>

    </div>

    <div id="secondaryMap" class="map" tabindex="0"></div>

    <app-coordinates
      [clickEventOnMapCoordinates]="clickEventOnMapCoordinates"
      [selText]="selText"
      [applicationSettings]="applicationSettings"
      [center]="center ?? []"
      >
    </app-coordinates>
    <app-map-tools
      [mapObject]="mapObject"
      [selText]="selText"
      [lang]="lang"
      [mapLayers]="mapLayers"
      [secondaryMapObject]="secondaryMapObject"
    ></app-map-tools>
    @if (displayService.showFeatureDataActive$ | async) {
      <app-show-feature-data
        (closeShowFeatureDataEE)="destroyFeatureDataView()"
        [featureDataFeature]="featureDataFeature"
        [selText]="selText"
        [lang]="lang"
        [mapObject]="mapObject"
        [applicationSettings]="applicationSettings"
      ></app-show-feature-data>
    }

    <div id="showStationWithCreate">
      <app-create [selText]="selText" [applicationSettings]="applicationSettings" [lang]="lang">
      </app-create>
      <!-- Since this is now in showStationWithCreate flexbox, we need to propogate the height down so it dynamically resizes itself correctly
      display: contents -> was the fix!
      -->
      @if (displayService.showStationDataActive$ | async) {
        <app-show-station-data
          style = "display: contents; max-height: 100%;"
          (closeShowStationViewEE)="destroyStationDataView()"
          [stationDataFeature]="stationDataFeature"
          [selText]="selText"
          [lang]="lang"
          [applicationSettings]="applicationSettings"
          >
        </app-show-station-data>
      }
    </div>
    @if (applicationSettings?.option?.legendBar?.show && !isMobileView && !(displayService.splitMapActive$ | async)) {
    <app-legend-bar class="map-legend"
      [mapLayers]="mapLayers" [applicationSettings]="applicationSettings">
    </app-legend-bar>
    }
    <app-scalar-legend [mapLayers]="mapLayers"></app-scalar-legend>
  </div>

  @if (displayService.isSubAppActive) {
    <div class="sub-app-board">
      <ng-container #moduleContainer></ng-container>
    </div>
  }
    <!-- Having this sliderDiv and app-main-action-view in DOM ruins strandhreinsun currently -->
    @if (displayService.mainActionViewActive$ | async) {
      <div
        id = "actionViewSlider"
        (mousedown) = "slideBegin($event)"
        (touchstart) = "slideBegin($event)"
      >
        <div
          id = "sliderThumb"
          (click) = "toggleExpandedState()"  
        >
          <mat-icon>{{isMobileView ? "swap_vert" : "swap_horiz"}}</mat-icon>
        </div>
      </div>
    }
    @if (displayService.mainActionViewActive$ | async) {
      <app-main-action-view
        id = "mainActionView"
        [selText]="selText"
        [applicationSettings]="applicationSettings"
        [lang]="lang">
      </app-main-action-view>
    }
</div>

@if (showLayerLoadFailedNotification) {
  <div>
    <app-notification-popup
      [paragraphs]="notificationText"
      [selText]="selText"
    ></app-notification-popup>
  </div>
}

@if (startupNotification) {
  <div>
    <app-notification-popup
      [paragraphs]="startupNotificationText"
      [selText]="selText"
      >
    </app-notification-popup>
  </div>
}

@if (displayService.showExternalDataActive$ | async) {
  <app-show-external-data
    [externalDataFeature]="externalDataFeature"
    (destroyExternalDataViewEE)="destroyExternalDataView()"
    >
  </app-show-external-data>
}

@if (displayService.editFeatureActive$ | async) {
  <app-edit-feature-data
    [selText]="selText"
    [applicationSettings]="applicationSettings"
    [lang]="lang"
    >
  </app-edit-feature-data>
}